import { createSelector, createSlice } from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";
import { selectSelectedPlayer } from "../squad/squadSlice";

export function getIndivModData({ modId, url, ignoreCondition = false }) {
  return async (dispatch, getState) => {
    const playerPk = selectSelectedPlayer(getState()).pk;
    const { status, playerPk: playerPkDataLoaded } = selectIndivModData(
      getState(),
      modId
    );

    if (
      !ignoreCondition &&
      ((status !== "idle" && playerPk === playerPkDataLoaded) ||
        playerPk === null ||
        playerPk === undefined)
    ) {
      return;
    }

    dispatch(statsIndivActions.loadPending({ modId, playerPk }));

    return api
      .get(url || `analysis/v1/indiv/${modId}/?player=${playerPk}`)
      .then((res) =>
        dispatch(statsIndivActions.loadSucceeded({ modId, data: res.data }))
      )
      .catch((err) =>
        dispatch(
          statsIndivActions.loadRejected({
            modId,
            data: err.response?.data,
          })
        )
      );
  };
}

const initialState = {};

const statsIndivSlice = createSlice({
  name: "statsIndiv",
  initialState,
  reducers: {
    loadPending: (state, action) => {
      state[action.payload.modId] = {
        data: null,
        status: "pending",
        error: null,
        playerPk: action.payload.playerPk,
      };
    },
    loadSucceeded: (state, action) => {
      state[action.payload.modId].status = "fulfilled";
      state[action.payload.modId].data = action.payload.data;
    },
    loadRejected: (state, action) => {
      state[action.payload.modId].status = "rejected";
      state[action.payload.modId].error = action.payload.data;
    },
    invalidateCache: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase("auth/logout", () => initialState);
  },
});

export const statsIndivActions = statsIndivSlice.actions;

export const selectStatsIndiv = (state) => state.statsIndiv;

export const selectIndivModData = createSelector(
  [(state) => selectStatsIndiv(state), (state, modId) => modId],
  (data, modId) =>
    data[modId] || {
      data: null,
      status: "idle",
      error: null,
      playerPk: null,
    }
);

// memo ok
export const selectLoadedIndivModsIds = createSelector(
  [(state) => selectStatsIndiv(state)],
  (data) => Object.keys(data).map((d) => Number(d))
);

export default statsIndivSlice.reducer;
